import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  fetchPaymentUrl,
  fetchPayOSUrl,
  setPaymentMethod,
} from "@/redux/slices/paymentSlice";
import { formatPrice } from "../../Helpers/BaseHelper";
import vnpayLogo from "../../assets/img/vnpay.png";
import payosLogo from "../../assets/img/payos.jpg";

const PaymentDetails = ({
  userId,
  selectedTour,
  startDate,
  quantity,
  paymentUrl,
  message,
  success,
  discount,
}) => {
  const dispatch = useDispatch();
  const { selectedPaymentMethod, loading } = useSelector(
    (state) => state.payment
  );

  const [paymentData, setPaymentData] = useState({
    userId: userId,
    tourId: selectedTour.tourId,
    startDate: startDate,
    quantity: quantity,
    Amount: selectedTour.price * quantity,
    discountId: discount ? discount.discountId : 0, // Gửi ID mã giảm giá
  });

  useEffect(() => {
    setPaymentData((prev) => ({
      ...prev,
      discountId: discount ? discount.discountId : null,
      discountCode: discount ? discount.discountCode : null,
      discountAmount: discount
        ? (selectedTour.price * quantity * discount.discountPercentage) / 100
        : 0,
    }));
  }, [discount]);

  const handlePaymentMethodChange = (method) => {
    dispatch(setPaymentMethod(method));
  };

  const handlePayment = () => {
    if (selectedPaymentMethod === "vnpay") {
      dispatch(fetchPaymentUrl(paymentData)).then((result) => {
        console.log("Final VNPay URL:", result.payload);
        if (result.payload) {
          window.location.href = result.payload;
        }
      });
    } else if (selectedPaymentMethod === "payos") {
      dispatch(fetchPayOSUrl(paymentData)).then((result) => {
        console.log("Final PayOS URL:", result.payload);
        if (result.payload) {
          window.location.href = result.payload;
        }
      });
    }
  };

  return (
    <div className="card payment-details">
      {console.log(paymentData, "paymentData")}
      <div className="card-header">
        <h5>Thanh toán</h5>
      </div>
      <div className="card-body">
        {/* <!-- Credit Card --> */}
        <div className="credit-card-details">
          <div className="mb-3">
            <h6 className="fs-16 ">Thanh toán trực tuyến</h6>
          </div>
          <div className="card-detials mb-3">
            <div className="row g-3">
              <div className="col-lg-4 d-flex">
                <div
                  className={`card-content flex-fill ${
                    selectedPaymentMethod === "vnpay" ? "border-primary" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePaymentMethodChange("vnpay")}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div>
                      <img
                        src={vnpayLogo}
                        alt="image"
                        className="img-fluid mb-2"
                        style={{ width: "35%", height: "35%" }}
                      />
                      <p className="fs-16 fw-medium text-gray-6">
                        **** **** **** 2547
                      </p>
                    </div>
                    <div className="card-edit-icon">
                      <a href="#" className="rounded-circle">
                        {" "}
                        <span className=" d-flex align-items-center justify-content-center fs-14">
                          <i className="isax isax-edit-2"></i>
                        </span>
                      </a>
                    </div>
                  </div>
                  {/* <div>
                    <h6 className="fs-14 mb-1">Hết hạn</h6>
                    <span className="fs-14 fw-normal text-gray-6">
                      May 2026
                    </span>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-4 d-flex">
                <div
                  className={`card-content flex-fill ${
                    selectedPaymentMethod === "payos" ? "border-primary" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePaymentMethodChange("payos")}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div>
                      <img
                        src={payosLogo}
                        alt="image"
                        className="img-fluid mb-2"
                        style={{ width: "50%", height: "50%" }}
                      />
                      <p className="fs-16 fw-medium text-gray-6">
                        **** **** **** 2547
                      </p>
                    </div>
                    <div className="card-edit-icon">
                      <a href="#" className="rounded-circle">
                        {" "}
                        <span className=" d-flex align-items-center justify-content-center fs-14">
                          <i className="isax isax-edit-2"></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 d-flex">
                <div className="card-add flex-fill d-flex align-items-center justify-content-center">
                  <div className="add-option d-flex align-items-center justify-content-center">
                    <a
                      href="#"
                      id="open-folder"
                      className="rounded-circle d-flex align-items-center justify-content-center"
                    >
                      <span className="d-flex align-items-center justify-content-center">
                        <i className="isax isax-add"></i>
                      </span>
                    </a>
                    <input
                      type="file"
                      id="folder-input"
                      className="file-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="card-form">
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Card Holder Name</label>
                  <div className="user-icon">
                    <span className="input-icon fs-14">
                      <i className="isax isax-user"></i>
                    </span>
                    <input type="text" className="form-control " />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Card Number</label>
                  <div className="user-icon">
                    <span className="input-icon fs-14">
                      <i className="isax isax-card-tick"></i>
                    </span>
                    <input type="text" className="form-control " />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Expire Date</label>
                  <div className="user-icon">
                    <span className="input-icon fs-14">
                      <i className="isax isax-calendar-2"></i>
                    </span>
                    <input type="text" className="form-control " />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">CVV</label>
                  <div className="user-icon">
                    <span className="input-icon fs-14">
                      <i className="isax isax-check"></i>
                    </span>
                    <input type="text" className="form-control " />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        {/* <!-- /Credit Card --> */}

        <div className="d-flex align-items-center justify-content-end flex-wrap gap-2">
          <a
            href="#"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#booking-success"
            onClick={(e) => {
              e.preventDefault();
              handlePayment();
            }}
            disabled={loading}
          >
            {loading ? "Đang xử lý..." : "Xác nhận và thanh toán"}{" "}
            {discount
              ? formatPrice(
                  selectedTour.price *
                    quantity *
                    (1 - discount.discountPercentage / 100)
                )
              : formatPrice(selectedTour.price * quantity)}{" "}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
